import { motion } from "framer-motion";

const STUDIO = "/about-studio.jpg";
const PRODUCT = "https://static.prod-images.emergentagent.com/jobs/8ce62d96-f600-4cc0-a5c9-9697f10f5a02/images/9299373664d2bc26dbfa3db427d6e1a388c0ca9ed797e7b4cf09dfa86a2ec286.png";
const HEART = "https://customer-assets.emergentagent.com/job_miss-lolly-designs/artifacts/22257des_IMG_6302.jpeg";

export default function About() {
  return (
    <div data-testid="about-page" className="bg-ink">
      <section className="container-x section-y grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <p className="overline">About MLD</p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
            className="mt-4 font-display text-6xl md:text-7xl text-white">
            Hi, I'm <span className="text-rose">Lisa.</span>
          </motion.h1>

          <p className="mt-8 text-white/85 text-lg leading-relaxed">
            I'm the founder of Miss Lolly Designs (MLD). MLD started from something
            deeply personal and has grown into a creative space where fashion,
            personalisation and community come together.
          </p>
          <p className="mt-5 text-white/75 text-lg leading-relaxed">
            I specialise in custom denim, HTV vinyl printing, rhinestone detailing and
            transforming everyday clothing and accessories into one-of-a-kind statement
            pieces.
          </p>
          <p className="mt-5 text-white/75 text-lg leading-relaxed">
            Alongside my design work, I run creative workshops for children, teens and
            adults — heat presses, vinyl cutters, the actual industry tools — in a fun,
            relaxed and supportive studio. My focus is always on{" "}
            <span className="text-rose font-bold">creativity</span>,{" "}
            <span className="text-gold font-bold">confidence</span> and{" "}
            <span className="text-lime font-bold">expression</span> — not perfection.
          </p>
          <p className="mt-5 text-white/75 text-lg leading-relaxed">
            I grew up in a close-knit community where creativity, connection and shared
            experiences were a big part of everyday life — and that's the energy I bring
            to MLD. Welcoming, inclusive, inspiring. Everyone leaves with something they
            made and something they're proud to wear.
          </p>
          <p className="mt-5 text-white/75 text-lg leading-relaxed">
            Whether it's a custom jacket, a personalised tote, or a full creative
            workshop experience — my goal is simple: help people turn ideas into
            something real.
          </p>

          <p className="mt-12 font-display text-3xl md:text-4xl text-rose leading-tight">
            Where digital futures<br />meet handmade beginnings.
          </p>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-2 gap-3">
            <div className="aspect-[3/4] overflow-hidden border-2 border-white">
              <img src={STUDIO} alt="Customised denim jacket flat-lay with rhinestones, vinyl and craft tools" className="w-full h-full object-cover" />
            </div>
            <div className="space-y-3">
              <div className="aspect-square overflow-hidden border-2 border-white">
                <img src={PRODUCT} alt="Custom rhinestone denim" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square overflow-hidden border-2 border-white">
                <img src={HEART} alt="MLD pink heart logo on denim" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container-x section-y border-t-2 border-white/10">
        <div className="grid md:grid-cols-3 gap-5">
          {[
            { k: "01", h: "Creativity", t: "Mood-boards, sketches, the freedom to play. The best pieces always start somewhere unexpected.", color: "rose" },
            { k: "02", h: "Confidence", t: "Real tools. Real techniques. Heat presses, vinyl cutters, rhinestones — used the way the industry uses them.", color: "gold" },
            { k: "03", h: "Community", t: "An inclusive studio where children, teens and adults all leave wearing something they're proud of.", color: "lime" },
          ].map((b) => (
            <div key={b.k} className="card-brutal">
              <div className={`font-display text-5xl ${b.color === "rose" ? "text-rose" : b.color === "gold" ? "text-gold" : "text-lime"}`}>{b.k}</div>
              <h3 className="mt-3 font-display text-3xl text-white">{b.h}</h3>
              <p className="mt-2 text-white/70">{b.t}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
